import { useContext } from 'react';

import {
  ListSubheader,
  alpha,
  Box,
  List,
  styled,
  Button,
  ListItem
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
import BrightnessLowTwoToneIcon from '@mui/icons-material/BrightnessLowTwoTone';
import MmsTwoToneIcon from '@mui/icons-material/MmsTwoTone';
import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import BallotTwoToneIcon from '@mui/icons-material/BallotTwoTone';
import BeachAccessTwoToneIcon from '@mui/icons-material/BeachAccessTwoTone';
import EmojiEventsTwoToneIcon from '@mui/icons-material/EmojiEventsTwoTone';
import FilterVintageTwoToneIcon from '@mui/icons-material/FilterVintageTwoTone';
import HowToVoteTwoToneIcon from '@mui/icons-material/HowToVoteTwoTone';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import WorkspacesOutlinedIcon from '@mui/icons-material/WorkspacesOutlined';
import LocalPharmacyTwoToneIcon from '@mui/icons-material/LocalPharmacyTwoTone';
import RedeemTwoToneIcon from '@mui/icons-material/RedeemTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import TrafficTwoToneIcon from '@mui/icons-material/TrafficTwoTone';
import CheckBoxTwoToneIcon from '@mui/icons-material/CheckBoxTwoTone';
import ChromeReaderModeTwoToneIcon from '@mui/icons-material/ChromeReaderModeTwoTone';
import WorkspacePremiumTwoToneIcon from '@mui/icons-material/WorkspacePremiumTwoTone';
import CameraFrontTwoToneIcon from '@mui/icons-material/CameraFrontTwoTone';
import DisplaySettingsTwoToneIcon from '@mui/icons-material/DisplaySettingsTwoTone';

//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////

import Switch from '@mui/material/Switch';
//////////////////////////////////////////////////////////////////////////////////////////
import * as React from 'react';
// import ListSubheader from '@mui/material/ListSubheader';
// import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import HandymanIcon from '@mui/icons-material/Handyman';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

// //////////////Icons///////////////////////// //
import InventorySharpIcon from '@mui/icons-material/InventorySharp';
import WidgetsIcon from '@mui/icons-material/Widgets';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SettingsIcon from '@mui/icons-material/Settings';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import PeopleIcon from '@mui/icons-material/People';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
// import { DriveEta } from '@mui/icons-material';

//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////

const MenuWrapper = styled(Box)(
  ({ theme }) => `
  .MuiList-root {
    padding: ${theme.spacing(1)};

    & > .MuiList-root {
      padding: 0 ${theme.spacing(0)} ${theme.spacing(1)};
    }
  }

    .MuiListSubheader-root {
      text-transform: uppercase;
      font-weight: bold;
      font-size: ${theme.typography.pxToRem(12)};
      color: ${theme.colors.alpha.trueWhite[50]};
      padding: ${theme.spacing(0, 2.5)};
      line-height: 1.4;
    }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {

      .MuiListItem-root {
        padding: 1px 0;

        .MuiBadge-root {
          position: absolute;
          right: ${theme.spacing(3.2)};

          .MuiBadge-standard {
            background: ${theme.colors.primary.main};
            font-size: ${theme.typography.pxToRem(10)};
            font-weight: bold;
            text-transform: uppercase;
            color: ${theme.palette.primary.contrastText};
          }
        }

        .MuiButton-root {
          display: flex;
          color: ${theme.colors.alpha.trueWhite[70]};
          background-color: transparent;
          width: 100%;
          justify-content: flex-start;
          padding: ${theme.spacing(1.2, 3)};

          .MuiButton-startIcon,
          .MuiButton-endIcon {
            transition: ${theme.transitions.create(['color'])};

            .MuiSvgIcon-root {
              font-size: inherit;
              transition: none;
            }
          }

          .MuiButton-startIcon {
            color: ${theme.colors.alpha.trueWhite[30]};
            font-size: ${theme.typography.pxToRem(20)};
            margin-right: ${theme.spacing(1)};
          }

          .MuiButton-endIcon {
            color: ${theme.colors.alpha.trueWhite[50]};
            margin-left: auto;
            opacity: .8;
            font-size: ${theme.typography.pxToRem(20)};
          }

          &.active,
          &:hover {
            background-color: ${alpha(theme.colors.alpha.trueWhite[100], 0.06)};
            color: ${theme.colors.alpha.trueWhite[100]};

            .MuiButton-startIcon,
            .MuiButton-endIcon {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }

        &.Mui-children {
          flex-direction: column;

          .MuiBadge-root {
            position: absolute;
            right: ${theme.spacing(7)};
          }
        }

        .MuiCollapse-root {
          width: 100%;

          .MuiList-root {
            padding: ${theme.spacing(1, 0)};
          }

          .MuiListItem-root {
            padding: 1px 0;

            .MuiButton-root {
              padding: ${theme.spacing(0.8, 3)};

              .MuiBadge-root {
                right: ${theme.spacing(3.2)};
              }

              &:before {
                content: ' ';
                background: ${theme.colors.alpha.trueWhite[100]};
                opacity: 0;
                transition: ${theme.transitions.create([
                  'transform',
                  'opacity'
                ])};
                width: 6px;
                height: 6px;
                transform: scale(0);
                transform-origin: center;
                border-radius: 20px;
                margin-right: ${theme.spacing(1.8)};
              }

              &.active,
              &:hover {

                &:before {
                  transform: scale(1);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
`
);

const CustomListItemButton = {
  '&:hover, &.active': {
    bgcolor: 'rgba(217, 217, 217, 0.26)',
    color: 'white'
  }
};

function SidebarMenu() {
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  const [activeBtn, setActiveBtn] = React.useState(null);
  const [openStates, setOpenStates] = React.useState({});

  const toggleActive = (itemId, itemState) => {
    setActiveBtn((prevActiveBtn) => (prevActiveBtn === itemId ? null : itemId));
    if (itemState === 1) {
      toggleOpen(itemId);
    }
  };

  const toggleOpen = (itemId) => {
    setOpenStates((prevOpenStates) => ({
      ...prevOpenStates,
      [itemId]: !prevOpenStates[itemId] || false
    }));
  };

  const list = [
    {
      id: 1,
      title: 'DASHBOARDS',
      state: 0,
      path: '/servicePartner/servicePartnerDetailsPage',
      icon: <DashboardIcon />
    },
    {
      id: 2,
      title: 'Bookings',
      state: 1,
      icon: <WidgetsIcon />,
      sublist: [
        {
          id: 2.1,
          title: 'Services',
          path: '/bookings/services',
        },
        {
          id: 2.2,
          title: 'Booking',
          path: '/bookings/booking',
          icon: <GroupAddIcon />
        },
      ]
    },
    {
      id: 3,
      title: 'Subscriptions',
      state: 1,
      icon: <WidgetsIcon />,
      sublist: [
        {
          id: 3.1,
          title: 'Subscriptions',
          path: '/subscriptions',
          icon: <GroupAddIcon />
        },
        {
          id: 3.2,
          title: 'Scheduler',
          path: '/scheduler',
          icon: <GroupAddIcon />
        }
      ]
    },
    {
      id: 4,
      title: 'Customers',
      state: 1,
      icon: <IntegrationInstructionsIcon />,
      sublist: [
        {
          id: 4.1,
          title: 'Customer',
          path: '/customer/customer',
          icon: <GroupAddIcon />
        }
      ]
    },
    {
      id: 5,
      title: 'Service Partners',
      state: 1,
      icon: <WorkspacesOutlinedIcon />,
      sublist: [
        {
          id: 5.1,
          title: 'Service Partners',
          path: '/servicePartner',
          icon: <GroupAddIcon />
        },
      ]
    },
    {
      id: 6,
      title: 'Sales Partners',
      state: 1,
      icon: <WorkspacesOutlinedIcon />,
      sublist: [
        {
          id: 6.1,
          title: 'Sales Partners',
          path: '/settings/salesPartner',
          icon: <PeopleIcon />
        },
      ]
    },
    {
      id: 7,
      title: 'Reports',
      state: 1,
      icon: <WorkspacesOutlinedIcon />,
      sublist: [
        {
          id: 7.1,
          title: 'Customers',
          path: '/reports/customers',
          icon: <GroupAddIcon />
        },
        {
          id: 7.2,
          title: 'Service Partners',
          path: '/reports/service-partners',
          icon: <GroupAddIcon />
        },
        {
          id: 7.3,
          title: 'Sales Partners',
          path: '/reports/sales-partners',
          icon: <GroupAddIcon />
        },
        {
          id: 7.4,
          title: 'Services',
          path: '/reports/services',
          icon: <GroupAddIcon />
        },
        {
          id: 7.5,
          title: 'Subscriptions',
          path: '/reports/subscriptions',
          icon: <GroupAddIcon />
        },
      ]
    },
    {
      id: 8,
      title: 'Settings',
      state: 1,
      icon: <SettingsIcon />,
      sublist: [
        {
          id: 8.1,
          title: 'Regions',
          path: '/settings/regions',
          icon: <EditLocationIcon />
        },
        {
          id: 8.2,
          title: 'Cars',
          path: '/settings/cars',
          icon: <DriveEtaIcon />
        },
        {
          id: 8.3,
          title: 'Services',
          path: '/settings/services',
          icon: <HandymanIcon />
        },
        {
          id: 8.4,
          title: 'Prices',
          path: '/settings/price',
          icon: <CurrencyRupeeIcon />
        },
        {
          id: 8.5,
          title: 'Packages',
          path: '/settings/packages',
          icon: <InventorySharpIcon />
        },
        {
          id: 8.6,
          title: 'User Management',
          path: '/settings/user-management',
          icon: <PeopleIcon />
        },
        {
          id: 8.7,
          title: 'Sales Partners',
          path: '/settings/salesPartner',
          icon: <PeopleIcon />
        },
        {
          id: 8.8,
          title: "Customer App Config",
          path: '/settings/customer-app-config',
          icon: <AppSettingsAltIcon />
        }
      ]
    }
  ];

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  const { closeSidebar } = useContext(SidebarContext);
  const [changeMenu, setChangeMenu] = React.useState(false);
  /////////////////////////////////////////////////////////////////////////////////////////

  const handleChange = () => {
    setChangeMenu(!changeMenu);
  };

  return (
    <>
      <Switch defaultChecked={false} onChange={handleChange} />
      {changeMenu ? (
        <MenuWrapper>
          {/* <List component="div">
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/overview"
                    startIcon={<DesignServicesTwoToneIcon />}
                  >
                    Overview
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List> */}
          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Dashboards
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/dashboards/crypto"
                    startIcon={<BrightnessLowTwoToneIcon />}
                  >
                    Cryptocurrency
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/dashboards/messenger"
                    startIcon={<MmsTwoToneIcon />}
                  >
                    Messenger
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>
          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Management
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/management/transactions"
                    startIcon={<TableChartTwoToneIcon />}
                  >
                    Transactions List
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>
          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Accounts
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/management/profile/details"
                    startIcon={<AccountCircleTwoToneIcon />}
                  >
                    User Profile
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/management/profile/settings"
                    startIcon={<DisplaySettingsTwoToneIcon />}
                  >
                    Account Settings
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>
          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Components
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/buttons"
                    startIcon={<BallotTwoToneIcon />}
                  >
                    Buttons
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/modals"
                    startIcon={<BeachAccessTwoToneIcon />}
                  >
                    Modals
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/accordions"
                    startIcon={<EmojiEventsTwoToneIcon />}
                  >
                    Accordions
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/tabs"
                    startIcon={<FilterVintageTwoToneIcon />}
                  >
                    Tabs
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/badges"
                    startIcon={<HowToVoteTwoToneIcon />}
                  >
                    Badges
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/tooltips"
                    startIcon={<LocalPharmacyTwoToneIcon />}
                  >
                    Tooltips
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/avatars"
                    startIcon={<RedeemTwoToneIcon />}
                  >
                    Avatars
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/cards"
                    startIcon={<SettingsTwoToneIcon />}
                  >
                    Cards
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/components/forms"
                    startIcon={<TrafficTwoToneIcon />}
                  >
                    Forms
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>
          <List
            component="div"
            subheader={
              <ListSubheader component="div" disableSticky>
                Extra Pages
              </ListSubheader>
            }
          >
            <SubMenuWrapper>
              <List component="div">
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/status/404"
                    startIcon={<CheckBoxTwoToneIcon />}
                  >
                    Error 404
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/status/500"
                    startIcon={<CameraFrontTwoToneIcon />}
                  >
                    Error 500
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/status/coming-soon"
                    startIcon={<ChromeReaderModeTwoToneIcon />}
                  >
                    Coming Soon
                  </Button>
                </ListItem>
                <ListItem component="div">
                  <Button
                    disableRipple
                    component={RouterLink}
                    onClick={closeSidebar}
                    to="/status/maintenance"
                    startIcon={<WorkspacePremiumTwoToneIcon />}
                  >
                    Maintenance
                  </Button>
                </ListItem>
              </List>
            </SubMenuWrapper>
          </List>
        </MenuWrapper>
      ) : (
        <>
          <List
            sx={{
              width: '100%',
              maxWidth: 360,
              bgcolor: 'bg',
              color: 'whitesmoke'
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
          >
            {list.map((item) => (
              <React.Fragment key={item.id}>
                {item.state === 0 ? (
                  <ListItemButton
                    onClick={() => toggleActive(item.id, item.state)}
                    sx={{ marginBottom: '3px', ...CustomListItemButton }}
                    component={RouterLink}
                    to={item.path}
                  >
                    <ListItemIcon
                      style={{ color: 'rgba(255, 255, 255, 0.44)' }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                  </ListItemButton>
                ) : (
                  <ListItemButton
                    onClick={() => toggleActive(item.id, item.state)}
                    sx={{ marginBottom: '3px', CustomListItemButton }}
                  >
                    <ListItemIcon
                      style={{ color: 'rgba(255, 255, 255, 0.44)' }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                    {openStates[item.id] ? <ExpandLess /> : <ExpandMore />}
                  </ListItemButton>
                )}
                {item.state === 1 && (
                  <Collapse
                    in={openStates[item.id]}
                    timeout="auto"
                    unmountOnExit
                    style={{ color: 'rgba(255, 255, 255, 0.44)' }}
                  >
                    <List component="div" disablePadding>
                      {item.sublist.map((subItem) => (
                        <ListItemButton
                          key={subItem.id}
                          sx={{
                            marginBottom: '3px',
                            pl: 4,
                            ...CustomListItemButton
                          }}
                          onClick={() => toggleActive(subItem.id, item.state)}
                          component={RouterLink}
                          to={subItem.path}
                        >
                          {/* <ListItemIcon
                            style={{ color: 'rgba(255, 255, 255, 0.44)' }}
                          >
                            {subItem.icon}
                          </ListItemIcon> */}
                          <ListItemText primary={subItem.title} />
                        </ListItemButton>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </>
      )}
    </>
  );
}

export default SidebarMenu;
